module.exports = __webpack_public_path__ + "static/img/xiazailuxiang2.938bf2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/xiazailuxiang2.png
// module id = wOVH
// module chunks = 24